import { Dimensions } from './Dimensions';
import { EventManager } from '../Tools/EventManager';
export class Events extends Dimensions {
    constructor(selector) {
        super(selector);
    }
    on(eventNames, selectorOrCallback, callbackOrUseCapture, useCapture) {
        if (typeof eventNames == 'string')
            eventNames = [eventNames];
        let selector = '';
        let callback;
        if (typeof selectorOrCallback == 'function') {
            callback = selectorOrCallback;
            useCapture = callbackOrUseCapture;
        }
        else {
            selector = selectorOrCallback;
            callback = callbackOrUseCapture;
        }
        if (typeof callback != 'function')
            return this;
        eventNames.forEach((eventName) => {
            this.forEach((item) => {
                EventManager.add(item, eventName, selector, callback, useCapture || false);
            });
        });
        return this;
    }
    off(eventNames, selector) {
        if (typeof eventNames == 'string')
            eventNames = [eventNames];
        eventNames.forEach((eventName) => {
            this.forEach((item) => {
                EventManager.remove(item, eventName, selector);
            });
        });
        return this;
    }
    /**
     * Trigger an event handler function for one or more events to the selected elements.
     *
     * @category Events
     *
     */
    trigger(eventName) {
        const event = new Event(eventName, {
            bubbles: true,
            cancelable: false
        });
        this.forEach((item) => {
            item.dispatchEvent(event);
        });
        return this;
    }
}
